import axios from 'axios';

// Alinha a base da API com services/api.js:
// - Se REACT_APP_API_BASE ou REACT_APP_API_URL estiverem definidas, usa exatamente como estão (sem adicionar/remover '/api' além de remover barra final).
// - Caso contrário, em produção (não localhost) usa same-origin '/api' para evitar CORS.
// - Em desenvolvimento local, usa 'http://localhost:3001'.
const inferBase = () => {
  const envBase = (process.env.REACT_APP_API_BASE || process.env.REACT_APP_API_URL || '').trim();
  if (envBase) return envBase.replace(/\/$/, '');

  const isBrowser = typeof window !== 'undefined' && typeof window.location !== 'undefined';
  const host = isBrowser ? window.location.hostname : '';
  const isLocalhost = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(host);
  if (!isLocalhost && isBrowser) {
    return '/api';
  }
  return 'http://localhost:3001';
};

const baseURL = inferBase();

const api = axios.create({
  baseURL,
  timeout: 10000, // 10 segundos
  headers: {
    'Content-Type': 'application/json',
  },
  // Em produção usamos token no corpo/headers, sem cookies cross-site
  withCredentials: false,
});

// Interceptor para requisições
api.interceptors.request.use(
  (config) => {
    // Adiciona token JWT, se existir
    try {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (_) {
      // ignora se localStorage não estiver disponível
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para respostas
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Tratamento de erros global
    if (error.response) {
      // Erros 4xx e 5xx
      const errorMessage = error.response.data?.message || 'Ocorreu um erro inesperado';
      return Promise.reject(new Error(errorMessage));
    } else if (error.request) {
      // A requisição foi feita mas não houve resposta
      return Promise.reject(new Error('Sem resposta do servidor. Verifique sua conexão.'));
    } else {
      // Erro ao fazer a requisição
      return Promise.reject(new Error('Erro ao processar a requisição.'));
    }
  }
);

export default api;
